// extracted by mini-css-extract-plugin
export var header = "_ve-1";
export var maskBottom = "_ve-6";
export var maskMiddle = "_ve-7";
export var maskTop = "_ve-5";
export var root = "_ve-0";
export var scrollDownButton = "_ve-3";
export var scrollDownButtonHidden = "_ve-4";
export var viewport = "_ve-2";